import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { INotification, NotificationsState } from './types';

export const initialState: NotificationsState = {
    notification: null
};

export const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        setNotification(state, action: PayloadAction<INotification>) {
            state.notification = {
                ...action.payload,
                date: new Date().toString()
            };
        },
        clearNotification(state) {
            state.notification = null;
        }
    }
});

export const { actions: notificationsActions } = notificationSlice;

export const useNotificationsSlice = () => {
    return { actions: notificationSlice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useNotificationsSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
